import {
  GroupChannel,
  MessageCollection,
  MessageCollectionInitPolicy,
  MessageFilter,
} from '@sendbird/chat/groupChannel';
import { MessageTypeFilter, ReplyType } from '@sendbird/chat/message';
import { useGroupChannelContext } from '@sendbird/uikit-react/GroupChannel/context';
import { useQuery, type UseQueryOptions } from '@tanstack/react-query';
import { useRef } from 'react';

export const fetchFileMessageCollection = (
  channel: GroupChannel,
  startingPoint: number
): Promise<MessageCollection> =>
  new Promise((resolve, reject) => {
    const collection = channel.createMessageCollection({
      filter: new MessageFilter({
        messageTypeFilter: MessageTypeFilter.FILE,
        replyType: ReplyType.ALL,
      }),
      startingPoint,
      prevResultLimit: 10,
      nextResultLimit: 10,
    });

    collection
      .initialize(MessageCollectionInitPolicy.CACHE_AND_REPLACE_BY_API)
      .onApiResult((err) => (err ? reject(err) : resolve(collection)));
  });

export const useFetchFileMessageCollection = (
  startingPoint: number,
  options?: UseQueryOptions<MessageCollection | null>
) => {
  const { currentChannel } = useGroupChannelContext();
  const previous = useRef<MessageCollection>(undefined);
  const channelUrl = currentChannel.url;

  return useQuery<MessageCollection | null>({
    queryKey: ['file-messages', { channelUrl, startingPoint }],
    queryFn: async () => {
      previous.current?.dispose();
      const c = await fetchFileMessageCollection(currentChannel, startingPoint);
      previous.current = c;
      return c;
    },
    enabled: !!channelUrl,
    // staleTime: 5 * 60 * 1000,
    ...options,
  });
};
